import createError from 'http-errors';
import {exceleraApiClient} from '@/lib/fetchClient.ts';
import type {SystemRange} from '@/types/systems';
import type {ExceleraRangeModelsResponse} from '@/types/exceleraSystems';
import {initTemplate} from '@/server/data/systemConfigurator.ts';

const systemRangeModels = {};

export async function initRangeModels(range: SystemRange) {
  const data: ExceleraRangeModelsResponse = await exceleraApiClient()(`/wapi/v1/cms/systems/groups/${range.systemGroupId}/ranges/${range._id}/list`);
  const models = data.systems;
  systemRangeModels[range._id] = {
    ...range,
    models,
  }
  for(const model of models) {
    await initTemplate(model.template);
  }
}

export function getModelById(modelId: string) {
  for(const key in systemRangeModels) {
    const { models } = systemRangeModels[key];
    const model = models.find(m => m._id === modelId);
    if(model) {
      return model;
    }
  }
  throw createError(404, `The model _id = ${modelId} was not found.`);
}
export function getModelsByRangeId(rangeId: string) {
  const rangeModels = systemRangeModels[rangeId];
  if(rangeModels) {
    return rangeModels;
  }
  throw createError(404, `Models for range _id: ${rangeId} not found.`);
}
